
import { PhraseBankSection } from '..';

export const errorUnableToFetchWeather: PhraseBankSection = [
  `Error finding weather in your area. Guess we're a little tipsy too.`
];
